import React from 'react'

import { Container, ContainerButton } from './styles'
import { ModalCustomAlertProps } from './types'
import { Button } from '../Button'
import { PortalModal } from '~/components/shared/PortalModal'

export const ModalCustomAlert: React.FC<ModalCustomAlertProps> = ({ modalInfo, onClose, showCustomAlertModal }) => {
  if (!showCustomAlertModal) return null

  return (
    <PortalModal
      size={'small'}
      useMask={false}
      show={showCustomAlertModal}
      onClose={onClose}
      modalContainerProps={{
        style: { background: 'rgba(0, 0, 0, 0.3)' }
      }}
    >
      <Container>
        <h4>{modalInfo.title}</h4>
        <span>{modalInfo.subtitle}</span>
        <ContainerButton>
          <Button onClick={onClose}>{modalInfo.buttonMessage}</Button>
        </ContainerButton>
      </Container>
    </PortalModal>
  )
}
